<script setup>
/* global axios */
// Konusmayi AI asistana atarken o konusmaya OZEL talimat yazma penceresi.
//
// NEDEN ayri bir bilesen: ayni pencere iki yerden aciliyor - ustteki uc
// nokta menusu ve mesaja sag tik. Iki kopya yazmak, talimat alanini bir
// yerde duzeltip digerinde unutmak demekti.
//
// NEDEN talimat ISTEGE BAGLI: cogu atamada ek bir sey soylenmiyor.
// Zorunlu yapmak her atamaya bir engel koymak olurdu; bos birakip
// "Ata" demek yeterli.
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  show: { type: Boolean, default: false },
  accountId: { type: [String, Number], required: true },
  conversationId: { type: [String, Number], required: true },
  // Konusma zaten atanmissa mevcut talimat; duzenlemeye aciliyor.
  mevcutTalimat: { type: String, default: '' },
  // true: ilk atama, false: yalnizca talimati guncelle
  ilkAtama: { type: Boolean, default: true },
});

const emit = defineEmits(['kapat', 'tamam']);

// Secilebilir kutular ve mevcut secim atama ucundan geliyor; ayri bir
// istek acmamak icin ayni uc GET'te de ayni govdeyi donuyor.
const kutulariYukle = async () => {
  kutularYukleniyor.value = true;
  try {
    const { data } = await axios.get(
      `/api/v1/accounts/${props.accountId}/conversations/${props.conversationId}/ai-asistan`
    );
    kutular.value = data.kutular || [];
    kutuId.value = data.kutu_id || null;
  } catch (e) {
    // Liste gelmezse pencere yine calisir: kutu_id null gider ve sunucu
    // konusmanin kendi kutusunu kullanir.
    kutular.value = [];
  } finally {
    kutularYukleniyor.value = false;
  }
};

const { t } = useI18n();

const AZAMI = 2000;

const talimat = ref('');

// Hangi gelen kutusunun AYARLARI kullanilacak: katalog kaynaklari ve
// agentlar oradan okunuyor. Bu ozellik zaten asistana BAGLI OLMAYAN
// kutulardaki konusmalar icin var ve o kutularda genelde hicbir ayar
// yok; kullanici kurulumunu yaptigi kutuyu secebilmeli.
const kutuId = ref(null);
const kutular = ref([]);
const kutularYukleniyor = ref(false);
const islemde = ref(false);
// woot-modal iki yonlu baglama istiyor; prop salt okunur oldugu icin
// yerel bir ref uzerinden aynaliyoruz.
const acik = ref(props.show);

const kalan = computed(() => AZAMI - talimat.value.length);
const uzun = computed(() => talimat.value.length > AZAMI);

// Pencere her acildiginda mevcut talimatla dolduruluyor; kullanicinin
// onceki yazdigini gormeden uzerine yazmasi istenmiyor.
watch(
  () => props.show,
  yeni => {
    acik.value = yeni;
    if (yeni) {
      talimat.value = props.mevcutTalimat || '';
      kutulariYukle();
    }
  },
  { immediate: true }
);

const kapat = () => {
  acik.value = false;
  emit('kapat');
};

const kaydet = async () => {
  if (uzun.value) return;

  islemde.value = true;
  try {
    await axios.post(
      `/api/v1/accounts/${props.accountId}/conversations/${props.conversationId}/ai-asistan`,
      { atandi: true, talimat: talimat.value.trim(), kutu_id: kutuId.value }
    );
    useAlert(
      props.ilkAtama
        ? t('CONVERSATION.OMNUP_AI.ATANDI')
        : t('CONVERSATION.OMNUP_AI.TALIMAT_KAYDEDILDI')
    );
    emit('tamam');
  } catch (e) {
    useAlert(
      e?.response?.data?.error || t('CONVERSATION.OMNUP_AI.HATA')
    );
  } finally {
    islemde.value = false;
  }
};
</script>

<template>
  <woot-modal v-model:show="acik" :on-close="kapat">
    <div class="flex flex-col gap-4 p-8">
      <div class="flex flex-col gap-1">
        <h2 class="text-lg font-medium text-n-slate-12">
          {{
            ilkAtama
              ? t('CONVERSATION.OMNUP_AI.PENCERE_BASLIK')
              : t('CONVERSATION.OMNUP_AI.PENCERE_BASLIK_DUZENLE')
          }}
        </h2>
        <p class="text-sm text-n-slate-11">
          {{ t('CONVERSATION.OMNUP_AI.PENCERE_ACIKLAMA') }}
        </p>
      </div>

      <!-- Ayar kutusu. Katalog kaynaklari ve agentlar buradan okunuyor;
           konusmanin kendi kutusunda kurulum olmayabilir. -->
      <label v-if="kutular.length > 1" class="flex flex-col gap-1">
        <span class="text-sm text-n-slate-12">
          {{ t('CONVERSATION.OMNUP_AI.KUTU_ETIKET') }}
        </span>
        <select
          v-model="kutuId"
          class="w-full px-3 py-2 text-sm border rounded-lg border-n-weak bg-n-solid-1 text-n-slate-12"
          :disabled="kutularYukleniyor"
        >
          <option v-for="k in kutular" :key="k.id" :value="k.id">
            {{ k.ad }}{{ k.kendi ? t('CONVERSATION.OMNUP_AI.KUTU_KENDI') : '' }} —
            {{
              t('CONVERSATION.OMNUP_AI.KUTU_OZET', {
                katalog: k.katalog
                  ? t('CONVERSATION.OMNUP_AI.KUTU_KATALOG_VAR')
                  : t('CONVERSATION.OMNUP_AI.KUTU_KATALOG_YOK'),
                agent: k.agent,
              })
            }}
          </option>
        </select>
        <span class="text-xs text-n-slate-10">
          {{ t('CONVERSATION.OMNUP_AI.KUTU_ACIKLAMA') }}
        </span>
      </label>

      <label class="flex flex-col gap-1">
        <span class="text-sm text-n-slate-12">
          {{ t('CONVERSATION.OMNUP_AI.TALIMAT_ETIKET') }}
          <span class="text-n-slate-10">
            {{ t('CONVERSATION.OMNUP_AI.ISTEGE_BAGLI') }}
          </span>
        </span>
        <textarea
          v-model="talimat"
          rows="4"
          class="w-full px-3 py-2 text-sm border rounded-lg resize-y border-n-weak bg-n-solid-1 text-n-slate-12"
          :placeholder="t('CONVERSATION.OMNUP_AI.TALIMAT_YER')"
        />
        <span
          class="text-xs"
          :class="uzun ? 'text-n-ruby-11' : 'text-n-slate-10'"
        >
          {{ t('CONVERSATION.OMNUP_AI.KALAN_KARAKTER', { sayi: kalan }) }}
        </span>
      </label>

      <p class="px-3 py-2 text-xs rounded-lg bg-n-alpha-1 text-n-slate-11">
        {{ t('CONVERSATION.OMNUP_AI.TALIMAT_NOT') }}
      </p>

      <div class="flex justify-end gap-2">
        <Button
          variant="ghost"
          color="slate"
          :label="t('CONVERSATION.OMNUP_AI.VAZGEC')"
          :disabled="islemde"
          @click="kapat"
        />
        <Button
          variant="solid"
          :label="
            ilkAtama
              ? t('CONVERSATION.OMNUP_AI.ATA_DUGME')
              : t('CONVERSATION.OMNUP_AI.KAYDET')
          "
          :is-loading="islemde"
          :disabled="islemde || uzun"
          @click="kaydet"
        />
      </div>
    </div>
  </woot-modal>
</template>
